import React from "react";
import TabelaProdap from "features/shared/components/TabelaProdap";
import { planningTableViewColumns } from "./planningTableViewColumns";
import { withStyles } from "@material-ui/core";
import WarningAmberOutlined from "@mui/icons-material/WarningAmberOutlined";
import { tableStyles } from "./tableStyle";
import { useTranslations } from "adapters/i18n";
import { BannerAlert } from "features/shared/components";

function PlanningReportTable({
  planningsTableList,
  total,
  categories,
  formulas,
  periodTitles,
  classes,
  warning,
  isPrinting,
  tabelaEsquerda = true,
}) {
  const { t } = useTranslations();
  const lines =
    planningsTableList && total ? [...planningsTableList, total] : [];

  return (
    <div
      className={`${classes.tableContent} ${classes.reportTableContent}`}
      data-testId="Plannings-Report-Table"
    >
      {warning && (
        <BannerAlert
          className={classes.disclaimer}
          customIcon={<WarningAmberOutlined style={{ fill: "#F69B17" }} />}
          type="plain"
        >
          {warning}
        </BannerAlert>
      )}

      <TabelaProdap
        className={classes.tableContainer}
        hover={false}
        isPrinting={isPrinting}
        idCabecalhoTabela={"planningsTableHead"}
        colunas={planningTableViewColumns(t, {
          categories,
          formulas,
          periodTitles,
        })}
        ativarPaginacao={false}
        linhas={lines}
        tabelaEsquerda={tabelaEsquerda}
        noPaper={true}
      />
    </div>
  );
}

const styles = (theme) => ({
  ...tableStyles(theme),

  reportTableContent: {
    "& tbody > tr:last-child": {
      borderTop: "16px solid #fff",
      background: "#fafafa",
      minHeight: "60px",
    },
    "& tbody > tr:last-child:hover": {
      background: "#fafafa !important",
    },
    "& tr th:first-of-type, & tr td:first-of-type": {
      minWidth: "160px",
    },
    "& tr td:first-of-type > div": {
      margin: "0px",
    },
    "& td": {
      color: "#757575",
    },
  },
  disclaimer: {
    marginTop: "12px",
  },
});

export default withStyles(styles)(PlanningReportTable);
